// eslint-disable-next-line import/order
import { type FunctionComponent, type HTMLAttributes } from 'react';

import { LinkListContext, type LinkListItemColor } from './LinkListItem';

export interface LinkListProps
  extends Omit<HTMLAttributes<HTMLUListElement>, 'color'> {
  color?: LinkListItemColor;
}

/**
 * LinkList is a wrapper component for LinkListItem to keep semantics in html,
 * i.e. `ul`.
 */
export const LinkList: FunctionComponent<LinkListProps> = ({
  color,
  ...restProps
}) => (
  <LinkListContext.Provider value={color}>
    <ul className={'w-full'} {...restProps} />
  </LinkListContext.Provider>
);

LinkList.displayName = 'LinkList';
